import { Node as I, findChildrenInRange as b, Tracker as B, mergeAttributes as C } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { ImageNameEnum as a, ImageModeEnum as t } from "./image-enum.mjs";
const A = I.create({
  name: "image",
  addOptions() {
    return {
      inline: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      imageMode: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      href: {
        default: null
      },
      containerWidth: {
        default: "auto"
      },
      caption: {
        default: null
      },
      uploadingProps: {
        default: null
      },
      isMobileFullWidth: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", C(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: i }) => {
        let n;
        switch (e.imageMode) {
          case t.Inline: {
            n = a.Inline;
            break;
          }
          case t.BlockRight:
          case t.BlockCenter: {
            n = a.Block;
            break;
          }
          default: {
            n = "image";
            break;
          }
        }
        return i.insertContent({
          type: n,
          attrs: e
        });
      },
      toggleImageMode: (e) => ({ tr: i, commands: n }) => {
        const { doc: d, selection: f } = i, { from: u, to: g } = f, c = b(
          d,
          { from: u, to: g },
          (l) => l.type.name === a.Inline || l.type.name === a.Block
        );
        if (!c.length)
          return !1;
        const p = new B(i);
        return n.forEach(c, ({ node: l, pos: m }) => {
          const o = p.map(m);
          if (o.deleted)
            return !1;
          const h = {
            from: o.position,
            to: o.position + l.nodeSize
          }, k = n.insertContentAt(h, {
            type: e === t.Inline ? a.Inline : a.Block,
            attrs: {
              ...l.attrs,
              imageMode: e,
              caption: e === t.Inline ? void 0 : l.attrs.caption,
              float: e === t.BlockRight ? "right" : null
            }
          }), s = o.position - 1;
          if (s >= 0) {
            const r = i.doc.nodeAt(s);
            (r == null ? void 0 : r.type.name) === "paragraph" && r.nodeSize === 2 && i.delete(s, s + r.nodeSize);
          }
          return e === t.Inline && (l.attrs.imageMode === t.BlockCenter || l.attrs.imageMode === t.BlockRight) && n.setNodeSelection(u + 1), k;
        });
      }
    };
  }
});
export {
  A as Image
};
